module.exports = __webpack_public_path__ + "img/icon_red_medal.45ae65f3.png";